export const workOrderTitles = [
    'Ürün Kodu',   
    'Çerçeve',
    'Orta Travers',
    'Düz Destek',
    'DA1',
    'DA2',
    'DA3',
    'DA4',
    'DA5',
    'DA6',
    'Satır Ekle'
];

export const EnamelPaintingWorkOrderTitles = [
    'İş Emri No',
    'Ürün Adı',
    'Başlama Saati',
    'Bitiş Saati',
    'Asılan(Adet)',
    // 'Günlük Toplam Asılan(Adet)',
    'Satır Ekle',
];

